/**
 * @file     radius.ts
 * @readme   ./README.md
 * @purpose  Derives and re-exports the border-radius scale from layoutTokens as a standalone RadiusScale token object.
 */
import type { RadiusScale } from '@/core/types';
import { layoutTokens } from './layout';

export const radiusTokens: RadiusScale = {
  ...layoutTokens.radius
};
